import { State } from './state.type';

export const stateInitializer = (): State => {
	return {
		photos: [],
		status: 'idle',
		error: null,
		dealId: null
	};
};
